import { Notification } from 'features/notifications/state/notificationSlice'
import { addQueryParamsRecursive } from './searchParamsUtils'

export type AnyUrlSearchParam = string | number | boolean | undefined | null | object
export type AnyUrlSearchParams = Record<string, AnyUrlSearchParam>

export type AppQueryParams = {
  notify?: Partial<Notification>
}

export function navigateWithReload(uri: string | URL, queryParams?: AppQueryParams) {
  window.location.href = uriAddSearchParams(uri, queryParams)
}

export function openNewWindow(url: string | URL) {
  window.open(url, '_blank', 'noopener,noreferrer')
}

/**
 * Add search params to a URL or string
 *
 * @param uriOrString URL or string to add search params to
 * @param searchParams optional, parameters to add to the URL
 * @returns url string
 */
export function uriAddSearchParams(
  uriOrString: string | URL,
  searchParams?: AnyUrlSearchParams | URLSearchParams
): string {
  const isAbsolute =
    typeof uriOrString === 'string' ? uriOrString.startsWith('http://') || uriOrString.startsWith('https://') : true

  const url: URL = typeof uriOrString === 'string' ? new URL(uriOrString, window.location.href) : uriOrString

  if (searchParams) {
    addQueryParamsRecursive(url.searchParams, searchParams)
  }
  return isAbsolute ? url.toString() : `${url.pathname}${url.search}${url.hash}`
}

export function pathToAbsoluteUrl(path: string) {
  return `${window.location.origin}${path}`
}
